import type { LearningExercise } from "../types";

// Fachlich gegen BGB geprüft (reviewStatus "reviewed"). Finale beta-ready-Freigabe durch Vincent.
// Sortieraufgaben (kind "ordering"): orderItems in KORREKTER Reihenfolge; die App mischt sie.
export const orderings: LearningExercise[] = [
  {
    id: "hj-order-001",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "ordering",
    topic: "BGB AT - Willenserklärung",
    title: "Stationen einer empfangsbedürftigen Willenserklärung",
    prompt: "Bringe die Stationen einer empfangsbedürftigen Willenserklärung in die richtige Reihenfolge.",
    options: [],
    answers: [],
    orderItems: [
      "Abgabe der Willenserklärung",
      "Übermittlung an den Empfänger",
      "Zugang beim Empfänger (§ 130 Abs. 1 BGB)",
      "Wirksamwerden der Willenserklärung",
    ],
    explanation:
      "Eine empfangsbedürftige Willenserklärung wird mit Zugang wirksam (§ 130 Abs. 1 Satz 1 BGB). Davor liegt die Abgabe (Entäußerung mit Richtung auf den Empfänger) und die Übermittlung; erst der Zugang löst das Wirksamwerden aus.",
    sourceIds: ["bgb130"],
    sources: [{ id: "bgb130", label: "§ 130 BGB", url: "https://www.gesetze-im-internet.de/bgb/__130.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Schema",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-order-002",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "ordering",
    topic: "BGB AT - Anfechtung",
    title: "Prüfungsreihenfolge der Anfechtung",
    prompt: "Ordne die Prüfungsschritte einer Anfechtung in der gutachterlichen Reihenfolge.",
    options: [],
    answers: [],
    orderItems: [
      "Anfechtungsgrund (§§ 119, 120, 123 BGB)",
      "Anfechtungserklärung gegenüber dem Anfechtungsgegner (§ 143 BGB)",
      "Anfechtungsfrist gewahrt (§ 121 bzw. § 124 BGB)",
      "Rechtsfolge: Nichtigkeit ex tunc (§ 142 Abs. 1 BGB)",
    ],
    explanation:
      "Gutachterlich wird zuerst der Anfechtungsgrund geprüft, dann die fristgerechte Anfechtungserklärung gegenüber dem richtigen Gegner; liegt alles vor, folgt die Rechtsfolge der rückwirkenden Nichtigkeit (§ 142 Abs. 1 BGB).",
    sourceIds: ["bgb142"],
    sources: [{ id: "bgb142", label: "§ 142 BGB", url: "https://www.gesetze-im-internet.de/bgb/__142.html" }],
    level: "Anwendbar",
    levelNumber: 3,
    errorCategory: "Schema",
    skillTags: ["bgb-at", "anfechtung"],
    reviewStatus: "beta-ready",
  },
];
